import { render, staticRenderFns } from "./importData.vue?vue&type=template&id=f91bcd2a&scoped=true&"
import script from "./importData.vue?vue&type=script&lang=js&"
export * from "./importData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91bcd2a",
  null
  
)

export default component.exports